export const GET_MODIFIER_GROUPS_REQUESTED =
  'GET_MODIFIER_GROUPS_REQUESTED'
export const GET_MODIFIER_GROUPS_SUCCEEDED =
  'GET_MODIFIER_GROUPS_SUCCEEDED'
export const GET_MODIFIER_GROUPS_FAILED = 'GET_MODIFIER_GROUPS_FAILED'

export const CREATE_MODIFIER_GROUP_REQUESTED =
  'CREATE_MODIFIER_GROUP_REQUESTED'
export const CREATE_MODIFIER_GROUP_SUCCEEDED =
  'CREATE_MODIFIER_GROUP_SUCCEEDED'
export const CREATE_MODIFIER_GROUP_FAILED =
  'CREATE_MODIFIER_GROUP_FAILED'

export const UPDATE_MODIFIER_GROUP_REQUESTED =
  'UPDATE_MODIFIER_GROUP_REQUESTED'
export const UPDATE_MODIFIER_GROUP_SUCCEEDED =
  'UPDATE_MODIFIER_GROUP_SUCCEEDED'
export const UPDATE_MODIFIER_GROUP_FAILED =
  'UPDATE_MODIFIER_GROUP_FAILED'

export const SET_MODIFIER_GROUPS_INDEXES =
  'SET_MODIFIER_GROUPS_INDEXES'

export const SEARCH_MODIFIER_GROUP_SUCCEEDED =
  'SEARCH_MODIFIER_GROUP_SUCCEEDED'

export const SET_MODIFIER_GROUPS_SORTING_MODE = `SET_MODIFIER_GROUPS_SORTING_MODE`
